import React, { type HTMLAttributes } from 'react';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ParagraphUSPSubparagraph as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphUSPSubparagraphProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphUSPSubparagraph: React.FC<ParagraphUSPSubparagraphProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS();

  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const image = paragraph.field_media_item[0];
  const mediaType = paragraph.field_media_item[0]?.bundle;

  return (
    <div className="ParagraphUSPSubparagraph col-12 col-md-6 col-lg-4">
      <div className="ParagraphUSPSubparagraph__content">

        {image && (
          <div className={`ParagraphUSPSubparagraph__media ${mediaType === 'svg' ? 'svg' : ''}`}>
            <DynamicMediaItem
              media={image}
              imageAspectRatio="1_1"
            />
          </div>
        )}

        <h3 className="ParagraphUSPSubparagraph__title">{title}</h3>
        {body && <WysiwygField html={body} />}
      </div>
    </div>
  );
};

export default ParagraphUSPSubparagraph;
